<div class="top">
  <div class="heading">
    <span class="fw-bold">CREATE WORKFLOW</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
    close
  </i>
</div>

<div class="form-wrapper">
  <form [formGroup]="form">
    <div class="form-fields">
      <div class="row g-1">
        <div class="col-md-6">
          <div class="field">
            <label for="name" class="required">WORKFLOW NAME</label>

            @if(!workflos){
            <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
            } @else{

            <ng-select [items]="workflos" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
              [hideSelected]="false" bindLabel="formattedName" bindValue="id" placeholder="Select"
              formControlName="workflowName" class="ng-select control role-select">
            </ng-select>

            }
            <app-error-message [form]="form" controlName="workflowName" label="Workflow Name"
              [showErrorMessage]="showErrorMessages"></app-error-message>
          </div>
        </div>


        <div class="col">
          <div class="field">
            <label for="name" class="required">LGA</label>

            @if(!lgas){
            <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
            } @else{

            <ng-select [items]="lgas" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
              [hideSelected]="false" bindLabel="formattedName" bindValue="id" placeholder="Select" formControlName="lga"
              class="ng-select control role-select" [class.hide-arrow]="isDisabled">
            </ng-select>

            }
            <app-error-message [form]="form" controlName="lga" label="LGA"
              [showErrorMessage]="showErrorMessages"></app-error-message>
          </div>
        </div>

        <div class="col">
          <div class="field">
            <label for="name" class="required">ZONE</label>

            @if(!workflos){
            <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
            }
            @else{
            <ng-select [items]="zoneList" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
              [hideSelected]="false" bindLabel="name" bindValue="id" placeholder="Select Zone"
              formControlName="zone" class="ng-select control role-select">
            </ng-select>
            }
            <app-error-message [form]="form" controlName="zone" label="Zone"
              [showErrorMessage]="showErrorMessages"></app-error-message>
          </div>
        </div>

        
      </div>

      <div class="field">
        <label class="required">DESCRIPTION</label>
        <textarea placeholder="description" class="form-control" formControlName="description"></textarea>
      </div>
      <form [formGroup]="approvalForm">
        <fieldset class="border p-3 rounded">
          <legend class="w-auto px-2 text-muted">Workflow Stage</legend>
          <div class="p-3">
            <div class="row">
              <div class="col">
                <div class="field">
                  <label for="name" class="required">APPROVING OFFICER</label>

                  @if(!admins){
                  <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
                  } @else{

                  <ng-select [items]="admins" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
                    [hideSelected]="false" bindLabel="formattedName" bindValue="id" placeholder="Select"
                    formControlName="approverId" class="ng-select control role-select">
                  </ng-select>

                  }
                  <app-error-message [form]="approvalForm" controlName="approverId" label="Approving officer"
                    [showErrorMessage]="showErrorMessages"></app-error-message>
                </div>
              </div>
              <div class="col">
                <div class="field">
                  <label for="name" class="required">APPROVAL STEP</label>

                  @if(!steges){
                  <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
                  } @else{
                  <ng-select [items]="steges" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
                    [hideSelected]="false" bindLabel="formattedName" bindValue="id" placeholder="Select"
                    formControlName="stageNumber" class="ng-select control role-select">
                  </ng-select>
                  }
                  <app-error-message [form]="approvalForm" controlName="stageNumber" label="Approval step"
                    [showErrorMessage]="showErrorMessages"></app-error-message>
                </div>
              </div>
            </div>
            <div class="field">
              <label class="required">ACTION</label>
              <div class="d-flex align-items-center gap-2">
                @if(!actions){
                <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
                } @else{
                <ng-select [items]="actions" [multiple]="false" [closeOnSelect]="true" [searchable]="true"
                  [hideSelected]="false" bindLabel="formattedName" bindValue="id" placeholder="Select"
                  formControlName="onApproved" class="ng-select control role-select w-100">
                </ng-select>
                }

                <button class="btn btn-dark d-flex align-items-center gap-1" [disabled]="isSubmitting"
                  style="flex-wrap: nowrap" (click)="addToList()">
                  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_8839_7438" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="0" y="0"
                      width="14" height="13">
                      <path
                        d="M6.70118 10.8201C9.12505 10.8201 11.0899 8.85527 11.0899 6.4314C11.0899 4.00754 9.12505 2.04272 6.70118 2.04272C4.27731 2.04272 2.3125 4.00754 2.3125 6.4314C2.3125 8.85527 4.27731 10.8201 6.70118 10.8201Z"
                        fill="white" stroke="white" stroke-width="4.06307" stroke-linejoin="round" />
                      <path d="M6.75616 4.24121V8.19102M4.78125 6.21612H8.73106" stroke="black" stroke-width="1.01577"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </mask>
                    <g mask="url(#mask0_8839_7438)">
                      <path d="M-13.1406 -13.4124H24.7776V24.5058H-13.1406V-13.4124Z" fill="white" />
                    </g>
                  </svg>
                  ADD
                </button>
              </div>

              <app-error-message [form]="form" controlName="numberOfTickets" label="Quantity"
                [showErrorMessage]="showErrorMessages"></app-error-message>
            </div>
          </div>
        </fieldset>
      </form>
    </div>

    <table class="custom-table table-bordered" *ngIf="approvalList.length >= 1">
      <thead class="custom-table-heading">
        <tr>
          <th class="ps-4">Officer</th>
          <th>Stage</th>
          <th class="text-center">On Action</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let x of approvalList; let i = index">
          <td>{{ getAdminNate(x.approverId)?.formattedName }}</td>
          <td>{{ getStages(x.stageNumber)?.formattedName }}</td>
          <td>{{ getAction(x.onApproved)?.formattedName }}</td>
          <td>
            <div class="d-flex justify-content-center">
              <button class="btn btn-danger table-action-btn" (click)="removeFromList(i)" [disabled]="isSubmitting">
                Delete
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </form>

  <div class="modal-actions-wrapper mt-3">
    <button type="submit" class="custom-btn-primary w-100" (click)="openConfirmModal()"
      [disabled]="approvalList.length < 1 || isSubmitting">
      <ng-container *ngIf="!isSubmitting; else loadingTemplate">
        <span>Create Workflow</span>
      </ng-container>
      <ng-template #loadingTemplate>
        <span>Creating workflow...</span>
      </ng-template>
    </button>
  </div>
</div>